// Package Imports
import { Button, Result } from 'antd'
import { useRouter } from '@tanstack/react-router'

// Core Imports
import { ROUTES } from '@/core/constants/routes'

type Props = {
  error: Error
  reset?: () => void
}

/**
 * Per-route error fallback. Mount via TanStack Router `errorComponent` so a
 * thrown render error inside one route doesn't blank the whole shell
 * (sidebar + header stay visible).
 */
const RouteError = ({ error, reset }: Props) => {
  const router = useRouter()
  console.error('[route-error]', error)

  const onRetry = () => {
    reset?.()
    router.invalidate()
  }

  return (
    <Result
      status="error"
      title="Bu sayfa yüklenemedi"
      subTitle={error.message || 'Beklenmeyen bir hata.'}
      extra={[
        <Button key="retry" type="primary" onClick={onRetry}>
          Yeniden Dene
        </Button>,
        <Button
          key="home"
          onClick={() => router.navigate({ to: ROUTES.dashboard })}
        >
          Anasayfaya Dön
        </Button>,
      ]}
    />
  )
}

export default RouteError
